import { render, staticRenderFns } from "./jy-onTheShelves.vue?vue&type=template&id=72be274a&scoped=true&"
import script from "./jy-onTheShelves.vue?vue&type=script&lang=js&"
export * from "./jy-onTheShelves.vue?vue&type=script&lang=js&"
import style0 from "./jy-onTheShelves.vue?vue&type=style&index=0&id=72be274a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be274a",
  null
  
)

export default component.exports